module.exports = __webpack_public_path__ + "media/images/register_image-281e80831995f3b86884b37033744b8e.png";